export * from "./DeleteIcon";
export * from "./GoogleIcon";
export * from "./IntoIcon";
export * from "./LikeIcon";
export * from "./NewIcon";
export * from "./DisLikeIcon";
export * from "./UploadIcon";
export * from "./CSVIcon";
export * from "./DocsIcon";
export * from "./AccountIcon";
export * from "./HelpIcon";
export * from "./LogoutIcon";
export * from "./FaceIcon";
export * from "./CloseIcon";
export * from "./CSVFileIcon";
export * from "./AlertIcon";
export * from "./RoundArrowIcon";
